export { default } from "./OutlineHeading";
